import type { GetPMNodeHeight } from '@atlaskit/editor-common/extensibility';
import type { ExtensionHandlers } from '@atlaskit/editor-common/extensions';
import type { ExtensionPluginOptions } from '@atlaskit/editor-plugin-extension';

interface Props {
	options: {
		__rendererExtensionOptions?: ExtensionPluginOptions['__rendererExtensionOptions'];
		extensionHandlers?: ExtensionHandlers;
		getExtensionHeight?: GetPMNodeHeight;
	};
}

export function extensionPluginOptions({ options }: Props): ExtensionPluginOptions {
	return {
		breakoutEnabled: true,
		extensionHandlers: options.extensionHandlers,
		useLongPressSelection: false,
		appearance: 'full-page',
		__rendererExtensionOptions: options.__rendererExtensionOptions,
		getExtensionHeight: options.getExtensionHeight,
	};
}
